export default __webpack_public_path__ + "static/media/truck.59dd3495.svg";